<template>
    <div class="relative flex column align_center justify_center card" :style="{ '--border-color': getRandomColor() }">
        <div class="label">{{ title }}</div>
        <div class="font_weight num_panel">
            {{ unitBefore || '' }}
            <span v-if="decimalPlaces > 0">{{ val | cny }}</span>
            <ICountUp v-else :delay="300" :endVal="+(val || 0) || 0" />
            {{ unitAfter || '' }}
        </div>
    </div>
</template>
<script>
import ICountUp from 'vue-countup-v2';
import { getRandomColor } from '@/lib/util';

export default {
    name: 'itemCard',
    components: {
        ICountUp,
    },
    props: ['title', 'val', 'unitBefore', 'unitAfter', 'decimalPlaces'],
    data() {
        return {
            //
        };
    },
    methods: {
        getRandomColor,
    },
};
</script>
<style lang="less" scoped>
.card {
    position: relative;
    min-width: 250px;
    max-width: 400px;
    height: 150px;
    border: 2px var(--border-color) solid;
    border-radius: 8px;
    .num_panel,
    .num_panel span {
        font-size: 40px;
        font-weight: bold;
    }
    .label {
        position: absolute;
        left: 10px;
        top: 10px;
    }
    .btn {
        bottom: 10px;
        cursor: pointer;
        text-align: center;
        color: blue;
    }
}
</style>
